import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { timer } from 'rxjs';
import { Constants } from 'src/app/app.constants';
import { TranslateOrgSpecificPipe } from '../pipes/translate-org-specific.pipe';

@Component({
  selector: 'app-confirm-box',
  templateUrl: './confirm-box.component.html',
  styleUrls: ['./confirm-box.component.css']
})
export class ConfirmBoxComponent implements OnInit {

  @Input() public data;
  confirmBtnLabel: string = null;
  cancelBtnLabel: string = null;
  message: string = null;
  user: string = null;
  isTimer: any;
  details: any;
  hideConfirm = false;

  constructor(public activeModal: NgbActiveModal
    , private translateOrgSpecific: TranslateOrgSpecificPipe
    , private router: Router) { }

  ngOnInit() {
    this.message = this.data.message;
    this.user = this.data.user;
    this.details = this.data.popupdata;
    const currentUrl = this.router.url;

    if (this.data.user == Constants.Client || this.data.user == Constants.Participants) {
      this.confirmBtnLabel = this.translateOrgSpecific.transform('Accept');
      this.cancelBtnLabel = this.translateOrgSpecific.transform('Reject');
      this.hideConfirm = currentUrl.includes('clientvideo/show') ? true : false;
    } else if (this.data.user == Constants.Clinician || this.data.user == Constants.CaseManager) {
      this.confirmBtnLabel = this.translateOrgSpecific.transform('Confirm');
      this.cancelBtnLabel = this.translateOrgSpecific.transform('Snooze');
      if (currentUrl.includes('clinicianvideo/casemanagement/show') || currentUrl.includes('clinicianvideo/show')) {
        this.hideConfirm = true;
      } else {
        this.hideConfirm = false;
      }
    }
    this.isTimer = timer(30000);
    this.isTimer.subscribe(x => {
      if (this.details.timerOff == false) {
        const result = { result: this.translateOrgSpecific.transform('Timeout'), data: this.details };
        this.activeModal.close(result);
      }
   });
  }

  onClose() {
    this.details.timerOff = true;
    const result = { result: this.cancelBtnLabel, data: this.data.popupdata };
    this.activeModal.close(result);
  }

  onConfirm() {
    this.details.timerOff = true;
    const result = { result: this.confirmBtnLabel, data: this.data.popupdata };
    this.activeModal.close(result);
  }



}
